import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import type { RootState } from '../app/store'
import Cookies from 'js-cookie'


//const BASE_URL = "http://localhost:3001"
const BASE_URL = "https://srv.app.coconnecter.com"


export const apiSlice = createApi({
    reducerPath: 'coConnecterApi',
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {

            // get token from cookies
            const token = Cookies.get('x-access-token');

            if (token) {
                headers.set('x-access-token', token)
            }
            return headers
        },
    }),
    endpoints: (builder) => ({
        signUpUser: builder.mutation({
            query: ({ userName, email, password }) => ({
                url: '/auth/signup',
                method: 'POST',
                body: {
                    username: userName,
                    email: email,
                    password: password,
                    roles: ["user"]
                }
            })
        }),
        signInUser: builder.mutation({
            query: (user) => ({
                url: '/auth/signin',
                method: 'POST',
                body: {
                    ...user
                }
            }),
            async onCacheEntryAdded(
                arg,
                {
                    dispatch,
                    getState,
                    extra,
                    requestId,
                    cacheEntryRemoved,
                    cacheDataLoaded,
                    getCacheEntry,
                }
            ) { },
        }),
        updateLexofficeSubscription: builder.mutation({
            query: (subscription) => ({
                url: '/lexoffice/createSubscriptions',
                method: 'PUT',
                body: {
                    ...subscription
                }
            })
        }),
        getLexofficeSubscription: builder.mutation({
            query: () => ({
                url: '/lexoffice/getSubscriptions',
                method: 'POST',
                body: {
                }
            })
        }),
        getAllUsers: builder.mutation({
            query: () => ({
                url: '/user/getAllUsers',
                method: 'POST',
                body: {
                }
            })
        }),
        changeUserMmLicence: builder.mutation({
            query: ({ userId, licence }) => ({
                url: '/user/updateUser',
                method: 'PUT',
                body: {
                    userId: userId,
                    syncClientLicence: licence
                }
            })
        }),
        changeUserCoLicence: builder.mutation({
            query: ({ userId, licence}) => ({
                url: '/user/updateUser',
                method: 'PUT',
                body: {
                    userId: userId,
                    coConnecterLicence: licence,
                }
            })
        }),
        getCurrentUser: builder.mutation({
            query: () => ({
                url: '/user/getCurrentUser',
                method: 'POST',
                body: {
                }
            })
        }),
        updateCurrentUser: builder.mutation({
            query: ({ user }) => ({
                url: '/user/updateUser',
                method: 'PUT',
                body: {
                    ...user
                }
            })
        }),
        changeApiKey: builder.mutation({
            query: (body) => ({
                url: '/user/updateUser',
                method: 'PUT',
                body: body
            })
        }),
        deleteLexOfficeSubscription: builder.mutation({
            query: ({ subscription }) => ({
                url: '/lexoffice/deleteSubscription',
                method: 'DELETE',
                body: {
                    subscription: subscription
                }
            })
        }),
        sevDeskGetSubscriptions: builder.mutation({
            query: () => ({
                url: '/sevdesk/getSubscriptions',
                method: 'POST',
                body: {

                }
            })
        }),
        sevDeskDeleteSubscription: builder.mutation({
            query: (body) => ({
                url: '/sevdesk/deleteSubscription',
                method: 'POST',
                body: body
            })
        }),
        sevDeskCreateSubscription: builder.mutation({
            query: (body) => ({
                url: '/sevdesk/createSubscription',
                method: 'POST',
                body: body
            })
        }),
        resetpassword: builder.mutation({
            query: ({ password, token, email }) => ({
                url: `/auth/resetpassword?token=${token}&email=${email}`,
                method: 'POST',
                body: {
                    password: password
                }
            })
        }),
        createResetPasswordMAil: builder.mutation({
            query: ({ email }) => ({
                
                url: '/auth/forgotPassword',
                method: 'POST',
                body: {
                    email: email
                }
            })
        }),
    })
})
  

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpointsexport const apiSlice = createApi({

export const useSignUpUser = apiSlice.endpoints.signUpUser.useMutation

export const useSignInUser = apiSlice.endpoints.signInUser.useMutation

export const useUpdateLexofficeSubscription = apiSlice.endpoints.updateLexofficeSubscription.useMutation

export const useGetLexofficeSubscription = apiSlice.endpoints.getLexofficeSubscription.useMutation

export const getAllUsers = apiSlice.endpoints.getAllUsers.useMutation

export const changeUserMmLicence = apiSlice.endpoints.changeUserMmLicence.useMutation

export const changeUserCoLicence = apiSlice.endpoints.changeUserCoLicence.useMutation

export const getCurrentUser = apiSlice.endpoints.getCurrentUser.useMutation

export const changeLexofficeAPIkey = apiSlice.endpoints.changeApiKey.useMutation

export const updateCurrentUser = apiSlice.endpoints.updateCurrentUser.useMutation

export const deleteLexOfficeSubscription = apiSlice.endpoints.deleteLexOfficeSubscription.useMutation

export const sevDeskGetSubscriptions = apiSlice.endpoints.sevDeskGetSubscriptions.useMutation

export const useCreatSevDeskSupscription = apiSlice.endpoints.sevDeskCreateSubscription.useMutation

export const useDeleteSevDeskSupscrition = apiSlice.endpoints.sevDeskDeleteSubscription.useMutation

export const useResetPassword = apiSlice.endpoints.resetpassword.useMutation

export const useCreateResetPasswordMail = apiSlice.endpoints.createResetPasswordMAil.useMutation

